import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import client, { formatApiError } from "@/api/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match"); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters"); return; }
    setError(""); setLoading(true);
    try {
      await client.post("/auth/reset-password", { token, new_password: password });
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) { setError(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-8">
      <div className="w-full max-w-sm fade-in">
        <div className="mb-8">
          <div className="w-10 h-10 bg-[#006080] rounded-lg flex items-center justify-center mb-4"><span className="text-white font-black">X</span></div>
          <h2 className="text-2xl font-bold text-gray-900">Set New Password</h2>
          <p className="text-gray-500 text-sm mt-1">Enter your new password below.</p>
        </div>
        {!token && <div className="p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-md">Invalid reset link. <Link to="/forgot-password" className="underline">Request a new one</Link>.</div>}
        {error && <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>}
        {success ? (
          <div className="p-4 rounded-md bg-green-50 border border-green-200 text-green-700 text-sm">Password reset successfully! Redirecting to login...</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-1.5"><Label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">New Password</Label><Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min. 6 characters" required className="bg-white border-gray-200" /></div>
            <div className="space-y-1.5"><Label className="text-xs uppercase tracking-widest text-gray-500 font-semibold">Confirm Password</Label><Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat password" required className="bg-white border-gray-200" /></div>
            <Button type="submit" className="w-full bg-[#006080] hover:bg-[#004d66] text-white font-semibold h-10" disabled={loading || !token}>{loading ? "Saving..." : "Reset Password"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
